import {sampleAccountsData} from "../../data/sample/SampleAccountsData";
import {accountsErrorAction, accountsLoadedAction, accountsLoadingAction} from "../actions";

export const fetchUserAccountsAction = () => {
    const massageData = (response) => {
        const formattedData = response.data.reduce((res, acc) => {
            if (!res[acc.plaidItemId]) {
                res[acc.plaidItemId] = [];
            }
            res[acc.plaidItemId].push(acc);
            return res;
        }, {});
        return formattedData;
    };


    return (dispatch, getState) => {
        const { accountsLoading } = getState();

        if (accountsLoading) {
            return console.log("accounts already loading...")
        }

        dispatch(accountsLoadingAction(true));
        const { user, csrfToken } = getState();

        if ( user !== null && user !== undefined && "email" in user) {
            let url = '/api/accounts/' + user.email;
            fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-XSRF-TOKEN': csrfToken,
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    const accounts = massageData({data: response});
                    dispatch(accountsLoadedAction(accounts));
                })
                .catch(err => {
                    dispatch(accountsErrorAction(JSON.stringify(err)));
                })
                .finally(() => {
                    console.log("done loading accounts.")
                });
        } else {
            dispatch(accountsErrorAction("User data is undefined, or field 'email' is missing. Loading sample data."));
            const sampleData = massageData({data: sampleAccountsData} );
            dispatch(accountsLoadedAction(sampleData));

        }
    }
};
